// extracted by mini-css-extract-plugin
module.exports = {"lia-box":"FloatingControlBox_lia-box__24IwU","lia-dropdown-item":"FloatingControlBox_lia-dropdown-item__LCwA5"};